import { useState, useEffect } from 'react';
import useSound from 'use-sound';
import correctAnswerBling from '../../sounds/correctAnswerBling.wav'
// import wrongAnswerBuzz from '../../sounds/wrongAnswerBuzz.wav'
import wrongAnswerBuzz from '../../sounds/fail.mp3'
import { getImageSource, konkatenoiKoonti, pisteytys } from '../../utils/utils';
import { shufflaa } from '../../utils/randomize'

import { data } from './data/data_01_B_tunkeuduttu'
// import kuva from './images/old_lady_shocked2.gif'
import kuva from './images/surprised_300x430.png'

const Scene_01_B_Tunkeuduttu = ({ scoreHandler, visibilityHandler, soundsOn, enimi, onimi }) => {

    //Statemjat
    const [teksti, setTeksti] = useState('')
    const [optiot1, setOptiot1] = useState([])
    const [optiot2, setOptiot2] = useState([])
    // const [optiot1Populoitu, setOptiot1Populoitu] = useState(false)
    // const [optiot2Populoitu, setOptiot2Populoitu] = useState(false)
    const [klikattuOptio, setKlikattuOptio] = useState('')

    // Vastausvaihtoehtojen ääniefektit
    const [playCorrectAnswer] = useSound(correctAnswerBling);
    const [playWrongAnswer] = useSound(wrongAnswerBuzz);

    let lista = null
    //populoi aluksi teksti + optiot (alkuperäinen järjestys)
    useEffect(() => {
        const source = data
        setOptiot1(source.optiot)
        // setOptiot1Populoitu(true)

        setTeksti(data.kysymysteksti)
    }, [])

    // optiot2:een shufflattu järjestys
    useEffect(() => {//
        if (optiot1.length != 0) {

            setOptiot2(shufflaa(optiot1))
        }
    }, [optiot1])

    useEffect(() => {//
        if (optiot2.length != 0) {

            optiot2.forEach(o => {
                o.teksti = o.teksti.replace("(oma nimi)", enimi)
                o.teksti = o.teksti.replace("(ohjaajan nimi)", onimi)
            });
        }
    }, [optiot2])

    const klikattuKuvaa = (optio) => {

        // optio = pisteytys(optio)
        if (soundsOn) {

            if (Number(optio.pisteet) > 0) {
                playCorrectAnswer()
            }
            else {
                playWrongAnswer()
            }

        }

        scoreHandler(optio, data.scene, data.maxp)

        visibilityHandler(optio.valinta)
    }

    if (optiot2.length != 0) {
        lista = optiot2.map(optio =>
            <li key={optio.id}>

                <span className='clickable'
                    onClick={() => klikattuKuvaa(optio)}
                >
                    {optio.teksti}
                </span>
            </li>
        );
    }
    return (
        <div className='sceneContainer'>

            <div id='image' className='kuvaBox'>
                <img src={kuva} alt='kuva' />
            </div>

            <div id='question'>
                <h4>{(teksti != null && teksti != "") ? teksti : null}</h4>
            </div>

            <div id='actions'>
                <ul>
                    {lista}
                </ul>
            </div>
        </div>

    )

}

export default Scene_01_B_Tunkeuduttu